// Debug file to check all imports
import { ThemeProvider } from './contexts/ThemeContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { AccessibleLayout } from './components/accessibility/AccessibleLayout'
import { MainLayout } from './components/layout/MainLayout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import Login from './pages/Login'
import { PartnerDashboard } from './pages/PartnerDashboard'
import { ClientManagement } from './pages/ClientManagement'
import { TaxManagement } from './pages/TaxManagement'
import { DocumentManagement } from './pages/DocumentManagement'
import { Reports } from './pages/Reports'
import { Analytics } from './pages/Analytics'
import { Support } from './pages/Support'
import { PartnerSettings } from './pages/Settings'
import { Accountants } from './pages/Accountants'
import { Whitelabel } from './pages/Whitelabel'
import { TeamManagement } from './pages/TeamManagement'
import { Webhooks } from './pages/Webhooks'

const imports = {
  ThemeProvider,
  NotificationProvider,
  AccessibleLayout,
  MainLayout,
  ProtectedRoute,
  Login,
  PartnerDashboard,
  ClientManagement,
  TaxManagement,
  DocumentManagement,
  Reports,
  Analytics,
  Support,
  PartnerSettings,
  Accountants,
  Whitelabel,
  TeamManagement,
  Webhooks
}

// Check for undefined imports
Object.entries(imports).forEach(([name, component]) => {
  if (component === undefined) {
    console.error(`UNDEFINED IMPORT: ${name}`)
  } else {
    console.log(`OK: ${name}`)
  }
})

export default imports
